import { useToast } from 'vue-toastification';

/**
 * Composable para tratamento de erros de API: exibe toast com a mensagem do erro e opcionalmente reseta loading.
 * A mensagem exibida é, por ordem: response.data.message → response.data.error → error.message → options.message.
 * @param {Object} options
 * @param {string} [options.message] - Mensagem de fallback quando o erro não traz mensagem (default: 'Ocorreu um erro. Tente novamente.')
 * @returns {{ handleError: (error: any, resetLoading?: () => void) => void }}
 */
export function useApiError(options = {}) {
  const toast = useToast();
  const defaultMessage = options.message || 'Ocorreu um erro. Tente novamente.';

  const handleError = (error, resetLoading) => {
    if (process.env.NODE_ENV !== 'production') {
      console.error(error);
    }
    const msg =
      error?.response?.data?.message ??
      error?.response?.data?.error ??
      (typeof error?.message === 'string' ? error.message : null) ??
      defaultMessage;
    toast.error(msg);
    if (typeof resetLoading === 'function') {
      resetLoading();
    }
  };

  return { handleError };
}
